<template>
  <div class="container" :class="{ 'selected': props.selected }">
    <div class="datum date">
      <span class="label">{{ tr('Specimen Collected Date') }}</span> <span>{{ collectionDate || '—' }}</span>
    </div>
    <div class="datum specimen-type">
      <span class="label">{{ tr('Specimen Type') }}</span> <span class="specimen-type-text">{{ specimenType || '—' }}</span>
    </div>
    <div class="datum test-type">
      <span class="label">{{ tr('Test Type') }}</span> <span class="genomics">Genomics</span>
      <span>{{ testType || '—' }}</span>
    </div>
    <div class="location">
      <span class="material-symbols-outlined size-24 location-icon">
        location_on
      </span>
      <span class="location-text">{{ labName || '—' }}</span>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { computed, defineProps } from 'vue'

const tr = (x) => x // inject('tr')

const props = defineProps({
  date: {
    type: String,
    default: '',
  },
  specimenType: {
    type: String,
    default: '',
  },
  testType: {
    type: String,
    default: '',
  },
  labName: {
    type: String,
    default: '',
  },
  selected: Boolean,
})

const collectionDate = computed(() => {
  const dateObject = new Date(props.date)
  if (dateObject.getDate()) {
    const month = dateObject.getMonth() + 1
    const date = dateObject.getDate()
    const year = dateObject.getFullYear()
    // TODO: consider adding language support for format here
    return `${month}.${date}.${year}`
  }
  return ''
})

// TODO: Specimen Type, Test Type, and Lab Name
// need to come from genomics back-end support

// const specimenType = 'Liquid Biopsy'
// const testType = 'Minimal Residual Disease (MRD) Dedection'
// const labName = 'Guardant'

const specimenType = computed(() => props.specimenType)
const testType = computed(() => props.testType)
const labName = computed(() => props.labName)
</script>

<style lang="scss" scoped>
.container {
  transform: scale(0.85);
  border-radius: 10px;
  background-color: #f9f9f9;
  overflow: auto;
  position: relative;
  text-align: left;
  margin: 0 0 -4% -2%;
  padding: 0;

  &:hover {
    cursor: pointer;
    background-color: var(--Grey100);
  }
}

.datum {
  margin: 5%;
  display: flex;
  flex-direction: column;
}

.genomics {
  width: max-content;
  border-radius: 4px;
  background-color: #e9ffaa;
  color: var(--Grey700);
  font-size: 80%;
  margin: 2px;
  padding: 5px;
}

.label {
  color: var(--Grey500);
  font-size: 70%;
  text-transform: uppercase;
}

.location {
  color: var(--Grey500);
  margin: -2% 5% 2% 5%;
  display: flex;
  flex-direction: row;
  font-size: 90%;
}

.location-icon {
  padding-bottom: 3px;
}

.location-text {
  padding-top: 3px;
}

.specimen-type-text {
  font-weight: bold;
}

.selected {
  border: 2px solid;
}
</style>
